<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Top Bar-->
				<div class="TopBar">
					<!--Search Options-->
					<div style="margin-bottom: 10px">
						<label>Start Date:</label>
						<p-calendar
							[disabled]="IsLoading() == true"
							showIcon="true"
							showButtonBar="true"
							showTime="true"
							[hourFormat]="12"
							[(ngModel)]="StartDate"
							name="StartDate"
							(ngModelChange)="onStartDateChange($event)"
						></p-calendar>

						<label style="margin-left: 10px">End Date:</label>
						<p-calendar
							[disabled]="IsLoading() == true"
							showIcon="true"
							showButtonBar="true"
							showTime="true"
							[hourFormat]="12"
							[(ngModel)]="EndDate"
							name="EndDate"
							(ngModelChange)="onEndDateChange($event)"
						></p-calendar>
					</div>

					<!--Buttons-->
					<div>
						<button
							[disabled]="IsLoading() == true"
							class="btn btn-primary"
							(click)="onRefresh()"
							[ngClass]="{
								'btn-primary': DatesChanged() == false,
								'btn-success': DatesChanged() == true
							}"
						>
							Refresh
						</button>
						<button style="margin-left: 5px" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSearch()">Search</button>
						<button style="margin-left: 5px" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onDeselectAll()">
							Deselect All
						</button>
						<img (click)="onToggleInfo()" class="info-img" src="assets/images/info-24.png" />

						<button
							style="margin-left: 5px"
							[ngClass]="{
								btn: true,
								'btn-success': PlaySounds == true,
								'btn-danger': PlaySounds == false
							}"
							(click)="onPlaySoundsClick()"
						>
							<i *ngIf="PlaySounds == true" class="fa fa-volume-up" aria-hidden="true"></i>
							<i *ngIf="PlaySounds == false" class="fa fa-volume-off" aria-hidden="true"></i>
							{{ PlaySounds == true ? " (Enabled)" : " (Disabled)" }}
						</button>
					</div>

					<div *ngIf="HistoryLoading == true" class="alert alert-info">
						<label>...Loading Please Wait. This can take a minute. Please do not refresh the page.</label>
						<div class="LoadingBarOuter">
							<div class="LoadingBarInner" [style.width]="LoadingBarWidth"></div><img src="assets/images/BusTrackerMap/BusIconsV4/Bus_Default.png" style="height: 20px;">
						</div>
					</div>

					<div *ngIf="ShowInfo == true" style="margin-top: 10px; margin-bottom: 15px">
						<div class="InfoBorder">
							<label>Buttons:</label><br />
							<label>&#9900; Start Date/End Date: Select a range to view bus/student history data</label><br />
							<label>&#9900; Play/Pause: Draws the buses positions over time</label><br />
							<label>&#9900; Search Button: Opens side bar to search for buses or students.</label><br />
							<label>&#9900; Deselect All Button: Deselects all selected items on the map.</label><br />
							<br />
							<br />
							<label>Overlays (which items/markes to put on the map):</label><br />
							<label>&#9900; Show Bus's Current Position: When selected displays a bus's approximate position on the map.</label><br />
							<label>&#9900; Show Known Locations: When selected displays a point where a bus went to based on its GPS data</label><br />
							<label
								>&#9900; Show Approximate Path: When selected it draws a line connecting all of the buses known positions (it's only an
								approximation and might go on and off of the road)</label
							><br />
							<label
								>&#9900; <span style="color: Red">Hide Unselected</span>: Hides buses, points, paths, and students that aren't selected (items
								are selected by clicking on them or searching for them in the selector). <span style="color: Red">NOTE:</span> Nothing will show
								up if you haven't selected any items in the selector</label
							><br />
							<label
								>&#9900; Center on Last Selected Bus: When selected it moves the map view to follow the last selected bus (from the selector or
								that you clicked on)</label
							><br />
							<label
								>&#9900; Show Buses From School(s): Select which schools to see data for. NOTE: if the district is hiding data from schools
								you're not assigned to (in the Transit Settings page) then all and my schools will look the same. Also, buses belong to a school
								if they are assigned 1 or more students that go to that school.</label
							><br />
							<label
								>&#9900; Severity: Show/hide buses based on alerts. Ex. Selecting High will show buses that will have a high alert at some point
								in their history.</label
							><br />
							<label>&#9900; Student Gets On Bus: When selected displays where students swiped on the the bus</label><br />
							<label>&#9900; Student Gets Off Bus: When selected displays where students swiped off the the bus</label><br />
							<label
								>&#9900; Show Students From School(s): Select which schools to see data for. NOTE: if the district is hiding data from schools
								you're not assigned to (in the Transit Settings page) then all and my schools will look the same.</label
							><br />
							<label
								>&#9900; Show Geo Fences: When selected displays geofences. These are maintained on the Geo Fence Maintenance page and can
								create an alert when a bus enters or leaves them.</label
							><br />
							<label
								>&#9900; Hide Inactive Geo Fences: When selected only active geofences are displayed (if Show Geo Fences is also selected). When
								its turned off all geofences are displayed, active or not</label
							><br />
							<br />
							<br />
							<label>Labels (what text displays next to a bus or student):</label><br />
							<br />
							<label>Buses:</label><br />
							<label>&#9900; Bus Number: Displays Bus's number on the map</label><br />
							<label>&#9900; Current Driver: Displays a bus's current driver. Can change over time (based on the data)</label><br />
							<label
								>&#9900; Current Route: Displays the bus's current route. Can change over time (changes when the driver selects a different
								route on the app)</label
							><br />
							<label
								>&#9900; Current Route Type: Displays the type of route a bus is currently on. Ex. Morning, Afternoon, Field Trip, etc. Can
								change over time (changes when the driver selects a different route on the app)</label
							><br />
							<label
								>&#9900; Bus Label Color: Select what color to use for bus labels. The Reset button sets the color to the default value.</label
							><br />
							<br />
							<label>Bus Locations:</label><br />
							<label>&#9900; Bus Number: Displays which bus was at that location</label><br />
							<label>&#9900; Date/Time: Displays when that point was recorded</label><br />
							<label>&#9900; Speed: Displays how fast the bus was going when it was at that location</label><br />
							<label>&#9900; Lat/Long: Displays latitude and longitude coordinates for that location</label><br />
							<label>&#9900; Driver: Displays who was driving the bus at that location</label><br />
							<label
								>&#9900; Location Label Color: Select what color to use for location labels. The Reset button sets the color to the default
								value.</label
							><br />
							<br />
							<label>Students:</label><br />
							<label>&#9900; Student Name: Displays Student's First and Last Name</label><br />
							<label>&#9900; Student ID: Displays Student's ID</label><br />
							<label
								>&#9900; Bus Entered or Exited: Displays the bus that recorded the transaction (which bus the student swiped on or off
								of)</label
							><br />
							<label>&#9900; Scan Time: Displays the time the student swiped on or off the bus at the marker's location</label><br />
							<label>&#9900; Scheduled Rider: Does the student belong on the bus they go on, or were they added manually?</label><br />
							<label
								>&#9900; Student Label Color: Select what color to use for student labels. Reset button sets the color to the default
								value.</label
							><br />
							<br />
							<br />
							<label>Time Player:</label><br />
							<label>&#9900; Current Time: Shows the time being displayed. Changing it will display new data.</label><br />
							<label>&#9900; Speed: Selects how fast to play back history data when you press the play button</label><br />
							<label>&#9900; Time Selector: Click or drag it to change the current time being displayed</label><br />
							<br />
						</div>

						<h4>Selector:</h4>
						<div class="InfoBorder">
							<label>&#9900; Selecting a bus will highlight the bus and show the stops it made.</label><br />
							<label>&#9900; Selecting a student will show their transactions and highlight the bus(es) they were on.</label><br />
							<br />
						</div>

						<h4>Map:</h4>
						<div class="InfoBorder">
							<label>Buses:</label><br />
							<label>&#9900; Right Click: Displays a popup with more info including a list of students on the bus</label><br />
							<label>&#9900; Left Click: Selects the bus. </label><br />
							<br />
							<label>Bus Locations:</label><br />
							<label>&#9900; Right Click: Displays a popup with more info about the data the bus sent to the server at that point.</label><br />
							<label>&#9900; Left Click: Selects the point. </label><br />
							<br />
							<label>Path:</label><br />
							<label>&#9900; Shows approximate path of the bus at a given time</label><br />
							<br />
							<label>Students:</label><br />
							<label>&#9900; Right Click: Displays a popup with more info</label><br />
							<label
								>&#9900; Left Click: Selects and highlights the student. If there are multiple student entries on the same spot, clicking on
								them will expand them in a spiral so you can see each entry. Pressing ESC or Delete will collapse the spiral</label
							><br />
							<label>&#9900; Students have an ON or OFF label underneath the icon which shows if they got on or off a bus at that stop</label
							><br />
							<br />
							<label>Geo Fence:</label><br />
							<label>&#9900; Maintained on Geo Fence Maintenance Screen</label><br />
							<label>&#9900; Right clicking on one shows more information</label><br />
							<br />
						</div>
					</div>

					<!--Options-->
					<div class="OptionsFlex">
						<!--Overlays-->
						<div class="OptionsBorder">
							<h5>Overlays</h5>

							<div class="OverlayGrid">
								<div>
									<label>Bus Positions</label>
									<div class="RadioGrid2Col">
										<label for="ShowBusLocation">Show Bus's Current Position:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowBusLocation"
											type="checkbox"
											[(ngModel)]="ShowBusLocation"
											(ngModelChange)="onShowBusLocationChange($event)"
										/>

										<label for="ShowKnownLocations">Show Known Locations:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowKnownLocations"
											type="checkbox"
											[(ngModel)]="ShowKnownLocations"
											(ngModelChange)="onShowKnownLocationsChange($event)"
										/>

										<label for="ShowAccuracyColor">Show Location Accuracy:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowAccuracyColor"
											type="checkbox"
											[(ngModel)]="ShowAccuracyColor"
											(ngModelChange)="onShowAccuracyColorChange($event)"
										/>

										<label>Inaccuracy Range:</label>
										<div style="display: flex; align-items: center">
											<input
												class="form-control"
												[disabled]="IsLoading() == true"
												type="number"
												min="0"
												[(ngModel)]="AccuracyFt"
												Step="10"
												(ngModelChange)="onAccuracyFtChange($event)"
											/>
											<label style="margin-left: 5px">ft</label>
										</div>

										<label for="ShowBusPath">Show Approximate Path:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowBusPath"
											type="checkbox"
											[(ngModel)]="ShowBusPath"
											(ngModelChange)="onShowBusPathChange($event)"
										/>

										<label style="color: Red" for="HideUnselected">Hide Unselected:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="HideUnselected"
											type="checkbox"
											[(ngModel)]="HideUnselected"
											(ngModelChange)="onHideUnselectedChange($event)"
										/>

										<label for="CenterOnSelected">Center on Last Selected Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="CenterOnSelected"
											type="checkbox"
											[(ngModel)]="CenterOnSelected"
											(ngModelChange)="onCenterOnSelectedChange($event)"
										/>

										<label>Show Buses From School(s):</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="BusSchoolOptionID"
											[(ngModel)]="BusSchoolOptionID"
											(ngModelChange)="onBusSchoolOptionIDChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstBusSchoolOption" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>

										<label *ngIf="BusSchoolOptionID == 2">School:</label>
										<p-dropdown
											*ngIf="BusSchoolOptionID == 2"
											[disabled]="IsLoading() == true"
											[options]="lstSchool"
											[(ngModel)]="BusSchool"
											optionLabel="SchoolFullName"
											[filter]="true"
											filterBy="SchoolFullName"
											[showClear]="false"
											placeholder="Select a School"
											(ngModelChange)="onBusSchoolChange($event)"
										>
											<ng-template pTemplate="selectedItem">
												<div *ngIf="BusSchool">
													<div class="form-control NoBorder" style="text-align: left">
														{{ BusSchool.SchoolFullName }}
													</div>
												</div>
											</ng-template>
											<ng-template let-SchoolItem pTemplate="item">
												<div>
													<div class="form-control NoBorder" style="text-align: left">
														{{ SchoolItem.SchoolFullName }}
													</div>
												</div>
											</ng-template>
										</p-dropdown>

										<label>Severity:</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="BusSeverityOption"
											[(ngModel)]="BusSeverityOption"
											(ngModelChange)="onBusSeverityOptionChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstSeverity" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Student Positions</label>
									<div class="RadioGrid2Col">
										<label for="ShowStudentsSwipeOn">Student Gets On Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentsSwipeOn"
											type="checkbox"
											[(ngModel)]="ShowStudentsSwipeOn"
											(ngModelChange)="onShowStudentsSwipeOnChange($event)"
										/>

										<label for="ShowStudentSwipeOff">Student Gets Off Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentSwipeOff"
											type="checkbox"
											[(ngModel)]="ShowStudentSwipeOff"
											(ngModelChange)="onShowStudentSwipeOffChange($event)"
										/>

										<label>Show Students From School(s):</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="StudentSchoolOptionID"
											[(ngModel)]="StudentSchoolOptionID"
											(ngModelChange)="onStudentSchoolOptionIDChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstStudentSchoolOption" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>

										<label *ngIf="StudentSchoolOptionID == 2">School:</label>
										<p-dropdown
											*ngIf="StudentSchoolOptionID == 2"
											[disabled]="IsLoading() == true"
											[options]="lstSchool"
											[(ngModel)]="StudentSchool"
											optionLabel="SchoolFullName"
											[filter]="true"
											filterBy="SchoolFullName"
											[showClear]="false"
											placeholder="Select a School"
											(ngModelChange)="onStudentSchoolChange($event)"
										>
											<ng-template pTemplate="selectedItem">
												<div *ngIf="StudentSchool">
													<div class="form-control NoBorder" style="text-align: left">
														{{ StudentSchool.SchoolFullName }}
													</div>
												</div>
											</ng-template>
											<ng-template let-SchoolItem pTemplate="item">
												<div>
													<div class="form-control NoBorder" style="text-align: left">
														{{ SchoolItem.SchoolFullName }}
													</div>
												</div>
											</ng-template>
										</p-dropdown>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Geo Fences</label>
									<div class="RadioGrid2Col">
										<label for="ShowGeoFences">Show Geo Fences:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowGeoFences"
											type="checkbox"
											[(ngModel)]="ShowGeoFences"
											(ngModelChange)="onShowGeoFencesChange($event)"
										/>

										<label for="HideInactiveGeoFences">Hide Inactive Geo Fences:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="HideInactiveGeoFences"
											type="checkbox"
											[(ngModel)]="HideInactiveGeoFences"
											(ngModelChange)="onHideInactiveGeoFencesChange($event)"
										/>
									</div>
								</div>
							</div>
						</div>

						<!--Labels-->
						<div class="OptionsFlexItem OptionsBorder">
							<h5>Labels</h5>

							<div class="LabelGrid">
								<div>
									<label>Bus Labels</label>

									<div class="RadioGrid2Col">
										<label for="BusShowBusNbr">Bus Number:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowBusNbr"
											type="checkbox"
											[(ngModel)]="BusShowBusNbr"
											(ngModelChange)="onBusShowBusNbrChange($event)"
										/>

										<label for="BusShowBusDriver">Current Driver:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowBusDriver"
											type="checkbox"
											[(ngModel)]="BusShowBusDriver"
											(ngModelChange)="onBusShowBusDriverChange($event)"
										/>

										<label for="BusShowCurrentRoute">Current Route:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowCurrentRoute"
											type="checkbox"
											[(ngModel)]="BusShowCurrentRoute"
											(ngModelChange)="onBusShowCurrentRouteChange($event)"
										/>

										<label for="BusShowRouteType">Current Route Type:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowRouteType"
											type="checkbox"
											[(ngModel)]="BusShowRouteType"
											(ngModelChange)="onBusShowRouteTypeChange($event)"
										/>

										<label for="BusShowAlertDesc">Alert Description:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowAlertDesc"
											type="checkbox"
											[(ngModel)]="BusShowAlertDesc"
											(ngModelChange)="onBusShowAlertDescChange($event)"
										/>

										<label [style.color]="BusTextColor">Bus Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="BusTextColor"
												(ngModelChange)="onBusTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetBusLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Bus Location Labels</label>

									<div class="RadioGrid2Col">
										<label for="KnownLocationShowBusNbr">Bus Number:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="KnownLocationShowBusNbr"
											type="checkbox"
											[(ngModel)]="KnownLocationShowBusNbr"
											(ngModelChange)="onKnownLocationShowBusNbrChange($event)"
										/>

										<label for="KnownLocationShowCDate">Date/Time:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="KnownLocationShowCDate"
											type="checkbox"
											[(ngModel)]="KnownLocationShowCDate"
											(ngModelChange)="onKnownLocationShowCDateChange($event)"
										/>

										<label for="KnownLocationShowSpeed">Speed:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="KnownLocationShowSpeed"
											type="checkbox"
											[(ngModel)]="KnownLocationShowSpeed"
											(ngModelChange)="onKnownLocationShowSpeedChange($event)"
										/>

										<label for="KnownLocationShowLatLong">Lat/Long:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="KnownLocationShowLatLong"
											type="checkbox"
											[(ngModel)]="KnownLocationShowLatLong"
											(ngModelChange)="onKnownLocationShowLatLongChange($event)"
										/>

										<label for="KnownLocationShowDriver">Driver:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="KnownLocationShowDriver"
											type="checkbox"
											[(ngModel)]="KnownLocationShowDriver"
											(ngModelChange)="onKnownLocationShowDriverChange($event)"
										/>

										<label [style.color]="LocationTextColor">Location Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="LocationTextColor"
												(ngModelChange)="onLocationTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetLocationLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Student Labels</label>

									<div class="RadioGrid2Col">
										<label for="ShowStudentName">Student Name:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentName"
											type="checkbox"
											[(ngModel)]="ShowStudentName"
											(ngModelChange)="onShowStudentNameChange($event)"
										/>

										<label for="ShowStudentID">Student ID:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentID"
											type="checkbox"
											[(ngModel)]="ShowStudentID"
											(ngModelChange)="onShowStudentIDChange($event)"
										/>

										<label for="ShowStudentBus">Bus Entered or Exited:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentBus"
											type="checkbox"
											[(ngModel)]="ShowStudentBus"
											(ngModelChange)="onShowStudentBusChange($event)"
										/>

										<label for="ShowStudentScanTime">Scan Time:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentScanTime"
											type="checkbox"
											[(ngModel)]="ShowStudentScanTime"
											(ngModelChange)="onShowStudentScanTimeChange($event)"
										/>

										<label for="ShowScheduledRider">Scheduled Rider:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowScheduledRider"
											type="checkbox"
											[(ngModel)]="ShowScheduledRider"
											(ngModelChange)="onShowScheduledRiderChange($event)"
										/>

										<label [style.color]="StudentTextColor">Student Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="StudentTextColor"
												(ngModelChange)="onStudentTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetStudentLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--Current Time Menu-->
					<div class="CurrentTimeDiv">
						<button
							class="btn btn-primary WidthFit"
							style="margin-top: 0px; margin-bottom: 0px"
							[disabled]="IsLoading() == true || lstBusHistory.length == 0"
							*ngIf="IsPlaying == false"
							(click)="onPlay()"
						>
							<i class="fa fa-play" aria-hidden="true"></i>
						</button>
						<button class="btn btn-danger WidthFit" [disabled]="IsLoading() == true" *ngIf="IsPlaying == true" (click)="onPause()">
							<i class="fa fa-pause" aria-hidden="true"></i>
						</button>

						<label class="WidthFit" style="min-width: 76px">Current Time:</label>
						<p-calendar
							class="WidthFit"
							style="min-width: 145px"
							[disabled]="IsLoading() == true || Processing == true || lstBusHistory.length == 0"
							showIcon="true"
							showButtonBar="true"
							showTime="true"
							[hourFormat]="12"
							showSeconds="true"
							[(ngModel)]="CurrentDT"
							name="CurrentDT"
							(ngModelChange)="onCurrentDTChange($event)"
						></p-calendar>

						<label style="margin-left: 10px">Speed:</label>

						<select class="form-control WidthFit" name="SpeedOption" [(ngModel)]="SpeedOption" (ngModelChange)="onSpeedOptionChange($event)">
							<option *ngFor="let r of lstSpeedOption" [ngValue]="r">
								{{ r.Desc }}
							</option>
						</select>

						<input
							type="range"
							min="0.001"
							max="610"
							step="0.01"
							[(ngModel)]="SecondsPerInterval"
							(ngModelChange)="onSecondsPerIntervalChange($event)"
						/>
					</div>

					<div class="TimeSliderDiv">
						<input
							[disabled]="IsLoading() == true || Processing == true || lstBusHistory.length == 0"
							style="margin-top: 5px"
							[min]="MinTime"
							[max]="MaxTime"
							step="60000"
							type="range"
							[(ngModel)]="CurrentTimeInt"
							(ngModelChange)="onCurrentTimeIntChange($event)"
						/>
					</div>
				</div>

				<!--Map-->
				<div
					[ngClass]="{
						MapGridOneCol: ShowSideBar == false,
						MapGridTwoCol: ShowSideBar == true
					}"
				>
					<p-gmap *ngIf="ShowMap == true" [overlays]="overlays" [options]="options" [style]="{ width: '100%', height: '625px' }"></p-gmap>

					<!--Side Bar for searching for buses or students-->
					<div *ngIf="ShowSideBar == true">
						<caass-bus-history-selector [StartDate]="StartDate" [EndDate]="EndDate" (SelectedChanged)="onSelectBusesOnMap($event)">
						</caass-bus-history-selector>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
